"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reduxFormWorksheet;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _reactButton = require("@flowio/react-button");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactStack = require("@flowio/react-stack");
var _reactWorksheet = require("@flowio/react-worksheet");
var _actions = require("./actions");
var _selectors = require("./selectors");
var _excluded = ["cancelButton", "open", "submitting", "saveButton", "title"];
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
function reduxFormWorksheet(initialConfig) {
  return function createReduxFormWorksheet(Form) {
    var config = _objectSpread({
      getFormOverlayState: _selectors.defaultStateSelector
    }, initialConfig);
    var ReduxForm = (0, _reduxForm.reduxForm)(config)(Form);
    var ReduxFormWorksheet = /*#__PURE__*/function (_Component) {
      (0, _inherits2.default)(ReduxFormWorksheet, _Component);
      var _super = _createSuper(ReduxFormWorksheet);
      function ReduxFormWorksheet(props, context) {
        var _this;
        (0, _classCallCheck2.default)(this, ReduxFormWorksheet);
        _this = _super.call(this, props, context);
        _this.handleCancel = _this.handleCancel.bind((0, _assertThisInitialized2.default)(_this));
        _this.handleSave = _this.handleSave.bind((0, _assertThisInitialized2.default)(_this));
        return _this;
      }
      (0, _createClass2.default)(ReduxFormWorksheet, [{
        key: "handleCancel",
        value: function handleCancel(event) {
          var onCancel = this.props.onCancel;
          event.preventDefault();
          event.stopPropagation();
          if (onCancel) onCancel();
        }
      }, {
        key: "handleSave",
        value: function handleSave(event) {
          var onSave = this.props.onSave;
          event.preventDefault();
          event.stopPropagation();
          if (onSave) onSave();
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
            cancelButton = _this$props.cancelButton,
            open = _this$props.open,
            submitting = _this$props.submitting,
            saveButton = _this$props.saveButton,
            title = _this$props.title,
            unhandledProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
          return /*#__PURE__*/_react.default.createElement(_reactWorksheet.Worksheet, {
            open: open
          }, /*#__PURE__*/_react.default.createElement(_reactWorksheet.WorksheetHeader, null, /*#__PURE__*/_react.default.createElement(_reactStack.Stack, {
            alignment: "center",
            distribution: "equalSpacing"
          }, (0, _reactButton.createButton)(cancelButton, {
            defaultProps: {
              disabled: submitting,
              onClick: this.handleCancel
            }
          }), /*#__PURE__*/_react.default.createElement(_reactWorksheet.WorksheetTitle, {
            content: title
          }), (0, _reactButton.createButton)(saveButton, {
            defaultProps: {
              disabled: submitting,
              onClick: this.handleSave
            }
          }))), /*#__PURE__*/_react.default.createElement(_reactWorksheet.WorksheetBody, null, /*#__PURE__*/_react.default.createElement(ReduxForm, unhandledProps)));
        }
      }]);
      return ReduxFormWorksheet;
    }(_react.Component);
    ReduxFormWorksheet.displayName = 'ReduxFormWorksheet';
    ReduxFormWorksheet.propTypes = {
      cancelButton: _propTypes.default.any,
      // eslint-disable-line react/forbid-prop-types
      open: _propTypes.default.bool,
      submitting: _propTypes.default.bool,
      onCancel: _propTypes.default.func,
      onSave: _propTypes.default.func,
      saveButton: _propTypes.default.any,
      // eslint-disable-line react/forbid-prop-types
      title: _propTypes.default.any // eslint-disable-line react/forbid-prop-types
    };

    ReduxFormWorksheet.defaultProps = {
      cancelButton: {
        content: 'Cancel',
        intent: 'neutral'
      },
      open: false,
      submitting: false,
      onCancel: undefined,
      onSave: undefined,
      saveButton: {
        content: 'Save',
        intent: 'primary'
      },
      title: undefined
    };
    function mapStateToProps(state, ownProps) {
      var form = ownProps.form,
        getFormOverlayState = ownProps.getFormOverlayState;
      var stateProps = (0, _selectors.getOverlayProps)(form, getFormOverlayState)(state);
      return _objectSpread(_objectSpread(_objectSpread({}, stateProps), ownProps), {}, {
        submitting: (0, _reduxForm.isSubmitting)(form, getFormOverlayState)(state)
      });
    }
    function mapDispatchToProps(dispatch, ownProps) {
      return {
        onCancel: function onCancel() {
          var form = ownProps.form,
            onCancel = ownProps.onCancel;
          dispatch((0, _actions.close)(form));
          if (onCancel) onCancel();
        },
        onSave: function onSave() {
          var form = ownProps.form,
            onSave = ownProps.onSave;
          dispatch((0, _reduxForm.submit)(form));
          if (onSave) onSave();
        },
        onSubmitSuccess: function onSubmitSuccess() {
          var form = ownProps.form,
            onSubmitSuccess = ownProps.onSubmitSuccess;
          dispatch((0, _actions.close)(form));
          if (onSubmitSuccess) onSubmitSuccess.apply(void 0, arguments);
        }
      };
    }
    var ConnectedReduxFormWorksheet = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReduxFormWorksheet);
    ConnectedReduxFormWorksheet.defaultProps = config;
    return ConnectedReduxFormWorksheet;
  };
}